import React, { useContext } from "react";
import { CloseIcon, ROUTES, zenvolyaNewLogo, railMascot } from "../../../../../constant";
import { StateContext } from "../../../../../context/globalContext/context";
import { iGlobalContext } from "../../../../../context/globalContext/interface";
import { GA_LABEL_ENUMS, triggerGAEvent } from "../../../../../constant/google-analytics/GAEvents";
import { useNavigationUrl } from "../../../../../hooks/useNavigationUrl";
import AppButton from "../../../../reusableComponent/button/button";
import styles from "./profile.module.scss";
interface iProfileProps {
  onClick: () => void;
  isLoggedIn: boolean;
  userName: string;
  handleClick: (event: React.MouseEvent<HTMLElement>) => void;
  isDesktopSidebarExpand: boolean;
  mode?: "full" | "mascot" | "avatar";
}

function ProfileDetails({
  onClick,
  isLoggedIn = false,
  userName = "",
  handleClick,
  isDesktopSidebarExpand,
  mode = "full",
}: iProfileProps): JSX.Element {
  const state = useContext(StateContext);
  const { isMobile, setScreen, setFirstScreen }: iGlobalContext = state;
  const { navigateWithParams } = useNavigationUrl();
  const handleLogoClick = () => {
    triggerGAEvent(GA_LABEL_ENUMS.home_zenvoya_logo_click);
    navigateWithParams(ROUTES.Home);
    setScreen("");
    setFirstScreen("");
  };

  if (mode === "mascot") {
    return (
      <div className={styles.railMascot}>
        <img src={railMascot} alt="" className={styles.railMascotImg} onClick={handleLogoClick} />
      </div>
    );
  }

  if (mode === "avatar") {
    return (
      <button type="button" className={styles.railAvatarBtn} onClick={handleClick} aria-label="Account menu">
        <div className={styles.railAvatar}>
          <p className={styles.railAvatarInitial}>{userName?.charAt(0)?.toUpperCase() || ""}</p>
        </div>
      </button>
    );
  }

  return (
    <div className={styles.container} style={{ width: isMobile ? "100%" : "max-content" }}>
      {isLoggedIn ? (
        <div className={styles.headerCard}>
          {!isMobile && (
            <div
              className={styles.logoCard}
              style={{
                width: isDesktopSidebarExpand ? "100%" : "30px",
                marginBottom: isDesktopSidebarExpand ? "5px" : "-10px",
              }}
            >
              <img src={zenvolyaNewLogo} alt="" className={styles.logo} onClick={handleLogoClick} />
            </div>
          )}
          <div className={styles.profile} onClick={handleClick}>
            <div className={styles.profileCard}>
              <p className={styles.profileName}>{userName?.charAt(0) || ""}</p>
            </div>
            {userName && <p className={styles.userName}>{userName}</p>}
          </div>
        </div>
      ) : (
        <div className={styles.deskTopLogoCard}>
          <img src={zenvolyaNewLogo} alt="" className={styles.deskLogo} onClick={handleLogoClick} />
        </div>
      )}
      {isMobile && (
        // <img src={CloseIcon} alt="" className={styles.closeIcon} onClick={onClick} />
        <AppButton
          iconBtn={CloseIcon}
          btnText=""
          onClick={() => {
            onClick();
            triggerGAEvent(GA_LABEL_ENUMS.home_side_bar_close_click);
          }}
          // iconHeight={14}
          variant="transparent"
          className={styles.closeIcon}
        />
      )}
    </div>
  );
}

export default ProfileDetails;
